import React from 'react'
import Head from '../../components/head'
import { Link } from '@reach/router'

export default class Covid extends React.Component {
    render() {
        return (

            <div className='bg-light' style={{ width: '100%', height: '100vh', overflow: 'auto' }}>
                <Head>
                    <title>Townhall-TH | COVID-19 Center</title>
                </Head>
                <div className='container p-4 flex-center' style={{ flexDirection: 'column' }}>
                    <h2 className='mb-5 mt-4 prompt text-dark text-center'>COVID-19 Center</h2>
                    <div className='container'>
                    <div className='row'>
                        <div className='col-md-6 mb-4'>
                            <Link to='/covid-19/crowdsource' className='d-block h-100 shadow rounded bg-white bg-card' style={{ color: 'inherit', textDecoration: 'none', backgroundImage: 'url(https://i.imgur.com/3qtlG7W.png)' }} />
                        </div>

                        <div className='col-md-6 mb-4'>
                            <Link to='/covid-19/cases' className='d-block h-100 shadow rounded bg-white bg-card' style={{ color: 'inherit', textDecoration: 'none', backgroundImage: 'url(https://i.imgur.com/8hhZe2R.png)' }}>
                                <div className='flex-center h-100'>
                                    <div className='w-100 p-2 purple-gradient text-white' style={{opacity: 0.8}}>
                                    <h3 className='text-center mb-0'>How it spreads?</h3>
                                    </div>
                                </div>
                            </Link>
                        </div>

                    </div>
                    </div>

                </div>

            </div>
        )
    }
}